import React, { useState, useRef } from "react";

const InputImagePremium = ({ onChange, label, name, value, errors = [], ...props }) => {
    const fileInputRef = useRef(null);
    const [fileError, setFileError] = useState("");

    const hasError = errors[name] || fileError;

    const serializeOnChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
            if (!allowedExtensions.exec(file.name)) {
                setFileError("Formato de arquivo não suportado. Por favor, selecione uma imagem com extensão .jpg, .jpeg, .png ou .gif.");
                return;
            }

            setFileError("");
            onChange(file);
        }
    };

    const handleBoxClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="w-100">
            {label && <label className="form-label text-muted small fw-bold mb-2">{label}</label>}

            <div
                className={`premium-image-upload-container ${value ? 'has-image' : ''} ${hasError ? 'border-danger' : ''}`}
                onClick={handleBoxClick}
            >
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={serializeOnChange}
                    accept="image/*"
                    {...props}
                />

                {value ? (
                    <>
                        <img src={value} alt="Preview" className="premium-image-preview" />
                        <div className="premium-image-overlay">
                            <i className="fa-solid fa-camera-rotate mb-2 fs-4 text-white"></i>
                            <span className="premium-image-upload-label">Mudar Imagem</span>
                        </div>
                    </>
                ) : (
                    <div className="premium-image-empty">
                        <i className="fa-solid fa-cloud-arrow-up"></i>
                        <span className="premium-image-upload-label">Upload de Capa</span>
                        <span className="text-muted" style={{ fontSize: '0.65rem' }}>JPG, PNG ou GIF</span>
                    </div>
                )}
            </div>

            {hasError && (
                <div className="text-danger mt-1" style={{ fontSize: '0.7rem' }}>
                    {fileError || (errors[name] && errors[name][0])}
                </div>
            )}
        </div>
    );
};

export default InputImagePremium;
